module.exports = __webpack_public_path__ + "img/helpCompanies.90033099.jpg";